/*
 * @创建文件时间: 2019-12-29 19:32:58
 * @Auther: lfq
 * @最后修改人        : lfq
 * @最后修改时间       : 2020-01-16 17:21:36
 * @联系Qq:1638245306
 * @文件介绍: 
 */
// 菜单 顶栏
export default [
    //     { path: '/gisMap', title: '综合管理平台', icon: 'home' }
]